import React from 'react'

function SliderList() {
  return (
    <div>SliderList</div>
  )
}

export default SliderList